// extracted by mini-css-extract-plugin
module.exports = {"ecBox":"Box_ecBox__aEMoC","ecBoxActive":"Box_ecBoxActive__ix1e7","showScale":"Box_showScale__VTHFO"};